import Logger from 'utils/Logger';
import { isCordova } from 'utils/platform';

function init() {
  Logger.logAnalytics('[Plausible] init');

  const scriptElement = document.createElement('script');
  scriptElement.src = isCordova()
    ? 'https://plausible.io/js/script.manual.js'
    : `https://plausible.io/js/script.js`;
  scriptElement.dataset.domain = PLAUSIBLE_DOMAIN;
  scriptElement.defer = true;
  document.head.appendChild(scriptElement);

  const scriptSetupElement = document.createElement('script');
  scriptSetupElement.innerHTML = `
  window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }
  `;
  document.head.appendChild(scriptSetupElement);
}

export default {
  init,
};
